var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FdInputGroup',[_c('template',{slot:"before"},[_vm._v("$")]),_c('FdInput',{attrs:{"value":"1234567"}})],2),_c('br'),_c('FdInputGroup',[_c('template',{slot:"after"},[_vm._v("€")]),_c('FdInput',{attrs:{"value":"1234567"}})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }